import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import useUserData from 'hooks/useUserData';
import { acceptBd100Terms } from 'services/bd100';
import { setUserData } from 'store/reducers/user-reducer';

export default function useAcceptBd100Terms() {
  const dispatch = useDispatch();
  const userData = useUserData();

  return useMutation(
    () =>
      acceptBd100Terms().then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message || 'Failed to accept BD100 terms');
        }
        return response.data;
      }),
    {
      onSuccess: () => {
        dispatch(setUserData({ ...userData, bd100_terms_accepted: true }));
      },
    }
  );
}
